import React from 'react';
import { Modal, Paper, Box, Typography, IconButton, Container } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

const ModalUrlWindow = ({ width, url, title, children }) => {
    const navigate = useNavigate();

    const handleClose = () => {
        if (url) {
            navigate(url);
        }
    };

    return (
        <Modal
            open={true}
            className='flex abs-center'
        >
            <Container maxWidth={width || 'md'}>
                <Paper style={{ padding: '20px', maxHeight: '90vh', overflow: 'auto' }}>
                    <Box className='flex stickSides fullW'>
                        <Box className='flex flexCol'>
                            <Box>
                                <Typography color={title.color ?? ''} variant={title.variant || 'body1'} className='flex abs-center'>
                                    {title.text}
                                </Typography>
                            </Box>
                        </Box>
                        <Box className='flex' alignItems='center'>
                            <IconButton
                                style={{ height: 'fit-content' }}
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box sx={{ marginTop: 2 }}>
                        {children}
                    </Box>
                </Paper>
            </Container>
        </Modal>
    );
};

export default ModalUrlWindow;
